import * as types from '../actions/types';

const initialState = {
  details: null,
  hasError: false,
  isOpen: false,
};

export default function(state = initialState, action) {
  const { error, type } = action;
  if (error) {
    return {
      details: error,
      hasError: true,
      isOpen: true,
    };
  } else if (type === types.HIDE_ERROR) {
    return {
      details: null,
      hasError: false,
      isOpen: false,
    };
  }

  return state;
}
